import React from "react";
import ReactTooltip from "react-tooltip";

function CustomToolTip(props) {
    const { id, title, place="top", effect="solid" } = props;
  return (
    <ReactTooltip 
      id={id} 
      place={place} 
      effect={effect}
      className="custom-tooltip"
      style={{ zIndex: 9999, maxWidth: '300px', whiteSpace: 'normal', wordBreak: 'break-word' }}
      multiline={true}
    >
      {title}
    </ReactTooltip>
  );
}

export default CustomToolTip;
